/**
 * Utility to convert Standard Algebraic Notation (SAN) from English (chess.js default)
 * to Spanish (standard for ChessDrez).
 *
 * English Piece Initials: K (King), Q (Queen), R (Rook), B (Bishop), N (Knight)
 * Spanish Piece Initials: R (Rey), D (Dama), T (Torre), A (Alfil), C (Caballo)
 */
export function translateSanToSpanish(san) {
    if (!san)
        return san;
    // Mapping of initials
    const mapping = {
        'K': 'R',
        'Q': 'D',
        'R': 'T',
        'B': 'A',
        'N': 'C'
    };
    // Replace the first character if it's an uppercase letter (piece initial)
    // Note: Pawns have no initial (e.g., "e4"), so we check if the first char is in mapping
    const initial = san.charAt(0);
    if (mapping[initial]) {
        return mapping[initial] + san.slice(1);
    }
    return san;
}
